import { useEffect } from 'react';

import type { IFrameMessageTypes } from './constants';
import { listenForMessages, type OnMessage } from './utils';

type ListenForIFrameMessagesOptions = {
  /**
   * Accept messages from these origins only. Pass a stable reference (a module
   * constant): the array is part of the effect's dependencies.
   */
  allowedOrigins?: readonly string[];
};

export const useListenForIFrameMessages = (
  messageType: IFrameMessageTypes,
  onMessage: OnMessage,
  options?: ListenForIFrameMessagesOptions
) => {
  const allowedOrigins = options?.allowedOrigins;
  useEffect(() => {
    return listenForMessages({
      onMessage,
      types: [messageType],
      allowedOrigins,
    });
  }, [messageType, onMessage, allowedOrigins]);
};
